import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';

const PriceE = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.containerHolder} ${color ? styles[color] : ''}`}>
		  {priceData.basePrice &&
			<div className={`${styles.oldPrice} ${styles.sizeBodyText}`}>{priceData.basePrice} {priceData.text}</div>
		  }

		  <div className={`${styles.container} ${styles.sizeBodyText}`}>
			  <div className={styles.prices}>
				  <div className={styles.priceContainer}>
					  <div className={`${styles.price} ${styles.sizeH4Medium}`}>
						  {priceData.price}
					  </div>
					  <div className={styles.currency}>
						  {priceData.text}
					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
	);
}

PriceE.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceE;
